export default "__VITE_ASSET__Dnnpmfld__"